import SubsectionContent from './SubsectionContent';

export default SubsectionContent;
